export default __webpack_public_path__ + "static/media/轮播首图4.4e77fcd5.jpg";